const finitePoint = (point) => Number.isFinite(Number(point?.x)) && Number.isFinite(Number(point?.y));
const inkPoints = (element) => (element.points || []).filter(finitePoint).map((point) => ({
  x: Math.max(0, Math.min(1600, Number(point.x))),
  y: Math.max(0, Math.min(900, Number(point.y))),
}));

// Drawing automatically leaves the latest stroke under the pointer. It must
// not silently narrow recognition to the last letter of a multiword phrase.
export const handwritingSelection = (page, selectedId = '', scope = 'page') => {
  const ink = (page?.elements || []).filter((element) => element.type === 'path' && inkPoints(element).length && !element.locked);
  return scope === 'selection' ? ink.filter((element) => element.id === selectedId) : ink;
};

// Only ink is sent to recognition, never teaching images or other board data.
// Render small/pencil writing at up to 2x resolution, keeping the full phrase
// and its spacing within the backend's 2000-pixel/2-MB image limits.
export const renderHandwriting = (elements) => {
  const ink = (elements || []).filter((element) => element.type === 'path').map((element) => ({ ...element, points: inkPoints(element) })).filter((element) => element.points.length);
  const points = ink.flatMap((element) => element.points);
  if (!points.length) throw new Error('Write on the board first, then choose Handwriting to text.');
  if (ink.length > 1000 || points.length > 100000) throw new Error('This page contains too much ink for one conversion. Move part of the writing to another page.');
  let minX = 1600; let minY = 900; let maxX = 0; let maxY = 0;
  points.forEach((point) => { minX = Math.min(minX, point.x); minY = Math.min(minY, point.y); maxX = Math.max(maxX, point.x); maxY = Math.max(maxY, point.y); });
  const padding = 40;
  const rawWidth = Math.max(100, maxX - minX + padding * 2);
  const rawHeight = Math.max(100, maxY - minY + padding * 2);
  const scale = Math.min(2, 2000 / rawWidth, 2000 / rawHeight);
  const canvas = document.createElement('canvas');
  canvas.width = Math.ceil(rawWidth * scale);
  canvas.height = Math.ceil(rawHeight * scale);
  const context = canvas.getContext('2d');
  if (!context) throw new Error('This browser cannot convert handwriting images.');
  context.fillStyle = '#ffffff'; context.fillRect(0, 0, canvas.width, canvas.height);
  context.strokeStyle = '#111111'; context.lineCap = 'round'; context.lineJoin = 'round';
  ink.forEach((element) => {
    context.lineWidth = Math.max(1.5, Math.min(30, Number(element.strokeWidth) || 4)) * scale;
    context.beginPath();
    element.points.forEach((point, index) => context[index ? 'lineTo' : 'moveTo']((point.x - minX + padding) * scale, (point.y - minY + padding) * scale));
    if (element.points.length === 1) context.lineTo((element.points[0].x - minX + padding + 0.1) * scale, (element.points[0].y - minY + padding) * scale);
    context.stroke();
  });
  const image = canvas.toDataURL('image/png');
  if (image.length > 2_666_690) throw new Error('The captured handwriting is too large. Use a smaller page of writing.');
  return { image, x: minX, y: minY, width: maxX - minX, height: maxY - minY };
};
